import { render } from "./leaves-employee-table.vue?vue&type=template&id=30ac42a8"
import script from "./leaves-employee-table.vue?vue&type=script&lang=js"
export * from "./leaves-employee-table.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__